import { render, staticRenderFns } from "./edit-system-promo.vue?vue&type=template&id=5a96c5c7&"
import script from "./edit-system-promo.vue?vue&type=script&lang=js&"
export * from "./edit-system-promo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports